<template>
    <!-- Admin → Permisos (/admin/permisos). Mismo diseño que Admin → Usuarios y
         Cupones (bkCuenta + cuentaMenu + usuariosAdmin.css) y permisosAdmin.css
         (prefijo pe-). Solo super admin (ruta requiresSuperAdmin + la API).

         Lógica y pedidos iguales que antes (AdminPermissionController,
         apiUrls.adminPermissions):
           GET    admin/permissions/admins
           POST   admin/permissions/admins {correo, admin_permissions, is_super_admin}
           PATCH  admin/permissions/admins/{id} {admin_permissions} | {is_super_admin}
           DELETE admin/permissions/admins/{id}   (le saca is_admin y los permisos)
         El rol define cuánto ve DENTRO de cada sección; los tildes, a cuáles
         entra. Las keys que no están en modules.json (accesos viejos) se
         conservan tal cual en cada PATCH. -->
    <div class="pe-page">
        <div class="bk us pe">
            <aside class="bk-side us-side">
                <router-link :to="{ name: 'admin' }" class="us-back">
                    <span aria-hidden="true" v-html="IC.back"></span>{{ $t('admin_permisos.back') }}
                </router-link>
                <h1 class="bk-title">{{ $t('admin_permisos.title_a') }} <span class="bk-grad">{{ $t('admin_permisos.title_b') }}</span></h1>
                <p class="bk-subtitle">{{ $t('admin_permisos.sub') }}</p>

                <div class="us-stats pe-stats" aria-live="polite">
                    <button v-for="r in ROLES" :key="r.v || 'todos'" type="button" :class="['us-stat', { 'is-on': rol === r.v }]" :aria-pressed="String(rol === r.v)" @click="rol = r.v">
                        <span class="us-stat-n">{{ cargando && !admins.length ? '—' : cuenta[r.k] }}</span>
                        <span class="us-stat-k">{{ $t(`admin_permisos.stat.${r.k}`) }}</span>
                    </button>
                </div>

                <div class="us-care pe-how">
                    <h2>{{ $t('admin_permisos.how.t') }}</h2>
                    <ul>
                        <li><span class="pe-how-b pe-how-b--sa">{{ $t('admin_permisos.role.super') }}</span>{{ $t('admin_permisos.how.super') }}</li>
                        <li><span class="pe-how-b">{{ $t('admin_permisos.role.admin') }}</span>{{ $t('admin_permisos.how.admin') }}</li>
                        <li><span class="pe-how-ic" aria-hidden="true" v-html="IC.check"></span>{{ $t('admin_permisos.how.sections') }}</li>
                    </ul>
                </div>
            </aside>

            <section class="us-main pe-main" :aria-busy="String(cargando)">
                <!-- Agregar admin -->
                <form class="pe-new" novalidate @submit.prevent="agregar">
                    <div class="pe-new-head">
                        <h2 class="pe-h">{{ $t('admin_permisos.new.title') }}</h2>
                        <p class="us-muted">{{ $t('admin_permisos.new.sub') }}</p>
                    </div>
                    <div class="pe-new-row">
                        <div :class="['us-field', 'pe-new-mail', { 'is-invalid': errCorreo }]">
                            <label class="us-field-l" for="pe-mail">{{ $t('admin_permisos.new.email') }}</label>
                            <input id="pe-mail" ref="correo" v-model.trim="nuevo.correo" type="email" maxlength="191" autocomplete="off" spellcheck="false" placeholder="admin@houseandflats.com" :aria-invalid="errCorreo ? 'true' : null" :aria-describedby="errCorreo ? 'pe-mail-e' : null" :disabled="agregando" @input="errCorreo = ''" />
                            <span v-if="errCorreo" id="pe-mail-e" class="us-field-e" role="alert">{{ errCorreo }}</span>
                        </div>
                        <fieldset class="us-field pe-new-role">
                            <legend class="us-field-l">{{ $t('admin_permisos.new.role') }}</legend>
                            <div class="us-seg">
                                <label :class="{ 'is-on': !nuevo.super }"><input v-model="nuevo.super" type="radio" name="pe-new-role" :value="false" :disabled="agregando" />{{ $t('admin_permisos.role.admin') }}</label>
                                <label :class="{ 'is-on': nuevo.super }"><input v-model="nuevo.super" type="radio" name="pe-new-role" :value="true" :disabled="agregando" />{{ $t('admin_permisos.role.super') }}</label>
                            </div>
                        </fieldset>
                    </div>
                    <p class="pe-role-hint">{{ $t(nuevo.super ? 'admin_permisos.role.hint_super' : 'admin_permisos.role.hint_admin') }}</p>

                    <div class="pe-mods-head">
                        <span class="us-field-l">{{ $t('admin_permisos.new.sections') }} <em>{{ $t('admin_permisos.mods.count', { n: nuevo.mods.length, t: modulos.length }) }}</em></span>
                        <div class="pe-mods-quick">
                            <button type="button" class="us-link" :disabled="agregando" @click="nuevo.mods = modulos.map(m => m.key)">{{ $t('admin_permisos.mods.all') }}</button>
                            <button type="button" class="us-link" :disabled="agregando" @click="nuevo.mods = []">{{ $t('admin_permisos.mods.none') }}</button>
                        </div>
                    </div>
                    <div class="pe-groups">
                        <fieldset v-for="g in grupos" :key="g.k" class="pe-group">
                            <legend>{{ $t(`admin_menu.g.${g.k}.t`) }}</legend>
                            <label v-for="m in g.mods" :key="m.key" :class="['pe-mod', { 'is-on': nuevo.mods.includes(m.key) }]">
                                <input v-model="nuevo.mods" type="checkbox" :value="m.key" :disabled="agregando" />
                                <span class="pe-mod-box" aria-hidden="true" v-html="IC.check"></span>
                                <span class="pe-mod-t">{{ titulo(m) }}<small v-if="m.superAdminOnly && !nuevo.super">{{ $t('admin_permisos.mods.needs_super') }}</small></span>
                            </label>
                        </fieldset>
                    </div>

                    <div class="pe-new-foot">
                        <button type="submit" class="bk-btn bk-btn--primary" :disabled="agregando">
                            <span v-if="agregando" class="bk-spinner"></span><span v-else aria-hidden="true" v-html="IC.plus"></span>{{ $t(agregando ? 'admin_permisos.new.adding' : 'admin_permisos.new.add') }}
                        </button>
                    </div>
                </form>

                <!-- Admins -->
                <div ref="lista" class="pe-list-head">
                    <h2 class="pe-h">{{ $t('admin_permisos.list.title') }}</h2>
                    <button type="button" class="us-link" :disabled="cargando" @click="cargar">
                        <span aria-hidden="true" v-html="IC.sync"></span>{{ $t(cargando ? 'admin_permisos.list.refreshing' : 'admin_permisos.list.refresh') }}
                    </button>
                </div>

                <div class="us-toolbar">
                    <label class="us-search">
                        <span class="us-sr">{{ $t('admin_permisos.list.search_label') }}</span>
                        <span aria-hidden="true" v-html="IC.search"></span>
                        <input v-model="q" type="search" autocomplete="off" spellcheck="false" :placeholder="$t('admin_permisos.list.search_ph')" />
                    </label>
                    <div class="us-filter-row">
                        <div class="us-seg us-seg--sm" role="group" :aria-label="$t('admin_permisos.list.filter')">
                            <button v-for="r in ROLES" :key="r.v || 'todos'" type="button" :class="{ 'is-on': rol === r.v }" :aria-pressed="String(rol === r.v)" @click="rol = r.v">
                                {{ $t(`admin_permisos.stat.${r.k}`) }} <span>{{ cuenta[r.k] }}</span>
                            </button>
                        </div>
                        <button v-if="q || rol" type="button" class="us-clear" @click="q = ''; rol = ''">{{ $t('admin_permisos.list.clear') }}</button>
                    </div>
                </div>

                <p v-if="!error && admins.length && (q || rol)" class="pe-count" aria-live="polite">{{ $tc('admin_permisos.list.count', visibles.length, { n: visibles.length }) }}</p>

                <div v-if="cargando && !admins.length" class="pe-loading"><HyFLoader variant="inline" /></div>
                <div v-else-if="error" class="us-empty">
                    <h3>{{ $t('admin_permisos.list.error_t') }}</h3>
                    <p>{{ $t('admin_permisos.list.error_p') }}</p>
                    <button type="button" class="bk-btn bk-btn--ghost" @click="cargar">{{ $t('admin_permisos.list.retry') }}</button>
                </div>
                <div v-else-if="!admins.length" class="us-empty">
                    <h3>{{ $t('admin_permisos.list.none_t') }}</h3>
                    <p>{{ $t('admin_permisos.list.none_p') }}</p>
                </div>
                <div v-else-if="!visibles.length" class="us-empty">
                    <h3>{{ q ? $t('admin_permisos.list.none_q_t', { q }) : $t('admin_permisos.list.none_f_t') }}</h3>
                    <p>{{ $t('admin_permisos.list.none_f_p') }}</p>
                    <button type="button" class="bk-btn bk-btn--ghost" @click="q = ''; rol = ''">{{ $t('admin_permisos.list.clear') }}</button>
                </div>

                <ul v-else :class="['pe-list', { 'is-cargando': cargando }]">
                    <li v-for="a in visibles" :key="a.idusuario" :class="['pe-card', { 'is-open': abiertos.includes(a.idusuario), 'is-new': resaltado === a.idusuario, 'is-saving': guardando === a.idusuario }]" :data-id="a.idusuario">
                        <div class="pe-card-top">
                            <div class="us-who pe-who">
                                <span :class="['us-av', a.is_super_admin ? 'us-av--p' : 'us-av--a']" aria-hidden="true">{{ iniciales(a) }}</span>
                                <div class="us-who-t">
                                    <b>{{ nombre(a) }}</b>
                                    <small>{{ a.correo }}</small>
                                </div>
                            </div>
                            <div class="pe-badges">
                                <span v-if="esYo(a)" class="us-badge">{{ $t('admin_permisos.list.you') }}</span>
                                <span v-if="a.role_locked" class="us-badge us-badge--adm" :title="$t('admin_permisos.list.owner_hint')">{{ $t('admin_permisos.list.owner') }}</span>
                                <span :class="['pe-role', { 'is-super': a.is_super_admin }]">{{ $t(a.is_super_admin ? 'admin_permisos.role.super' : 'admin_permisos.role.admin') }}</span>
                            </div>
                            <button type="button" class="bk-btn bk-btn--ghost pe-toggle" :aria-expanded="String(abiertos.includes(a.idusuario))" :aria-controls="`pe-ed-${a.idusuario}`" @click="alternar(a)">
                                {{ $t(abiertos.includes(a.idusuario) ? 'admin_permisos.list.close' : 'admin_permisos.list.edit') }}<span :class="['pe-chev', { 'is-up': abiertos.includes(a.idusuario) }]" aria-hidden="true" v-html="IC.down"></span>
                            </button>
                        </div>

                        <!-- Resumen de accesos (cerrado) -->
                        <div v-if="!abiertos.includes(a.idusuario)" class="pe-sum">
                            <span class="pe-sum-n">{{ $t('admin_permisos.mods.count', { n: activos(a).length, t: modulos.length }) }}</span>
                            <ul v-if="activos(a).length" class="pe-chips">
                                <li v-for="m in activos(a)" :key="m.key" :class="{ 'is-warn': m.superAdminOnly && !a.is_super_admin }" :title="m.superAdminOnly && !a.is_super_admin ? $t('admin_permisos.mods.needs_super_hint') : null">{{ titulo(m) }}</li>
                            </ul>
                            <span v-else class="pe-sum-none">{{ $t('admin_permisos.mods.empty') }}</span>
                        </div>

                        <!-- Edición (abierto) -->
                        <div v-else :id="`pe-ed-${a.idusuario}`" class="pe-edit">
                            <div class="pe-edit-row">
                                <fieldset class="us-field pe-role-field">
                                    <legend class="us-field-l">{{ $t('admin_permisos.new.role') }}</legend>
                                    <div class="us-seg us-seg--sm">
                                        <label v-for="r in [false, true]" :key="String(r)" :class="{ 'is-on': !!a.is_super_admin === r, 'is-off': rolBloqueado(a) }">
                                            <input type="radio" :name="`pe-role-${a.idusuario}`" :checked="!!a.is_super_admin === r" :disabled="rolBloqueado(a) || guardando === a.idusuario" @change="cambiarRol(a, r)" />{{ $t(r ? 'admin_permisos.role.super' : 'admin_permisos.role.admin') }}
                                        </label>
                                    </div>
                                    <span v-if="rolBloqueado(a)" class="us-field-h">{{ $t(a.role_locked ? 'admin_permisos.list.owner_hint' : 'admin_permisos.list.self_role') }}</span>
                                    <span v-else class="us-field-h">{{ $t(a.is_super_admin ? 'admin_permisos.role.hint_super' : 'admin_permisos.role.hint_admin') }}</span>
                                </fieldset>
                                <span v-if="guardando === a.idusuario" class="pe-saving" role="status"><span class="bk-spinner pe-spin" aria-hidden="true"></span>{{ $t('admin_permisos.list.saving') }}</span>
                            </div>

                            <div class="pe-mods-head">
                                <span class="us-field-l">{{ $t('admin_permisos.new.sections') }} <em>{{ $t('admin_permisos.mods.count', { n: activos(a).length, t: modulos.length }) }}</em></span>
                                <div class="pe-mods-quick">
                                    <button type="button" class="us-link" :disabled="guardando === a.idusuario" @click="todos(a, true)">{{ $t('admin_permisos.mods.all') }}</button>
                                    <button type="button" class="us-link" :disabled="guardando === a.idusuario" @click="todos(a, false)">{{ $t('admin_permisos.mods.none') }}</button>
                                </div>
                            </div>
                            <div class="pe-groups">
                                <fieldset v-for="g in grupos" :key="g.k" class="pe-group">
                                    <legend>{{ $t(`admin_menu.g.${g.k}.t`) }}</legend>
                                    <label v-for="m in g.mods" :key="m.key" :class="['pe-mod', { 'is-on': tiene(a, m.key), 'is-lock': propioPermisos(a, m) }]" :title="propioPermisos(a, m) ? $t('admin_permisos.mods.self_lock') : null">
                                        <input type="checkbox" :checked="tiene(a, m.key)" :disabled="propioPermisos(a, m) || guardando === a.idusuario" @change="alternarModulo(a, m.key, $event)" />
                                        <span class="pe-mod-box" aria-hidden="true" v-html="propioPermisos(a, m) ? IC.lock : IC.check"></span>
                                        <span class="pe-mod-t">{{ titulo(m) }}<small v-if="propioPermisos(a, m)">{{ $t('admin_permisos.mods.self_lock_s') }}</small><small v-else-if="m.superAdminOnly && !a.is_super_admin">{{ $t('admin_permisos.mods.needs_super') }}</small></span>
                                    </label>
                                </fieldset>
                            </div>

                            <div class="pe-edit-foot">
                                <span v-if="!a.role_locked && !esYo(a)" class="us-muted">{{ $t('admin_permisos.list.saved_auto') }}</span>
                                <span v-else class="us-muted">{{ $t(a.role_locked ? 'admin_permisos.list.owner_del' : 'admin_permisos.list.self_del') }}</span>
                                <button v-if="!a.role_locked && !esYo(a)" type="button" class="bk-btn bk-btn--ghost us-danger-btn" :disabled="guardando === a.idusuario" @click="quitar(a)">
                                    <span aria-hidden="true" v-html="IC.trash"></span>{{ $t('admin_permisos.list.remove') }}
                                </button>
                            </div>
                        </div>
                    </li>
                </ul>
            </section>
        </div>

        <!-- Confirmación -->
        <div v-if="modal" class="us-modal">
            <div class="us-modal-bg" @click="responderModal(false)"></div>
            <div ref="modalCard" class="us-modal-card" role="alertdialog" aria-modal="true" aria-labelledby="pe-m-title" aria-describedby="pe-m-text" @keydown="teclaModal">
                <h2 id="pe-m-title">{{ modal.titulo }}</h2>
                <p id="pe-m-text">{{ modal.texto }}</p>
                <div class="us-modal-btns">
                    <button type="button" class="bk-btn bk-btn--ghost" @click="responderModal(false)">{{ $t('admin_permisos.k.cancel') }}</button>
                    <button ref="modalOk" type="button" :class="['bk-btn', modal.peligro ? 'us-btn--danger' : 'bk-btn--primary']" @click="responderModal(true)">{{ modal.ok }}</button>
                </div>
            </div>
        </div>

        <transition name="us-toast">
            <div v-if="aviso" :class="['us-toast', `us-toast--${aviso.tipo}`]" role="status" aria-live="polite">
                <span class="us-toast-ico" aria-hidden="true">{{ aviso.tipo === 'ok' ? '✓' : '!' }}</span><span>{{ aviso.txt }}</span>
            </div>
        </transition>
    </div>
</template>

<script>
import axios from 'axios';
import { mapGetters } from 'vuex';
import apiUrls from '@/new-constants/apiUrls';
import modules from '@/components/Admin/modules.json';
import HyFLoader from '@/components/Loader/HyFLoader.vue';
import ICON from '@/components/Cuenta/iconos';

const P = d => `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">${d}</svg>`;
// Íconos: texto fijo de este archivo, nunca datos del usuario.
const IC = {
    back: P('<path d="M15 18l-6-6 6-6"/>'),
    check: P('<path d="M20 6 9 17l-5-5"/>'),
    down: P('<path d="m6 9 6 6 6-6"/>'),
    search: ICON.search, lock: ICON.lock, plus: ICON.plus, trash: ICON.trash, sync: ICON.sync,
};
// Mismas áreas y orden que el panel (/admin). Sin grupo → "otros".
const GRUPOS = ['inventario', 'reservas', 'clientes', 'marketing', 'usuarios', 'otros'];
const ROLES = [{ v: '', k: 'all' }, { v: 'super', k: 'super' }, { v: 'admin', k: 'admin' }];
const EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const norm = s => String(s || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();

export default {
    name: 'AdminPermissions',
    components: { HyFLoader },

    data() {
        const qy = this.$route.query;
        const rolQ = typeof qy.rol === 'string' && ROLES.some(r => r.v === qy.rol) ? qy.rol : '';
        return {
            IC, ROLES,
            admins: [], cargando: true, error: false,
            q: typeof qy.q === 'string' ? qy.q : '', rol: rolQ,
            abiertos: [], resaltado: null, guardando: null,
            nuevo: { correo: '', super: false, mods: [] }, errCorreo: '', agregando: false,
            modal: null, aviso: null,
        };
    },

    computed: {
        ...mapGetters(['isSuperAdmin']),
        modulos() { return modules; },
        grupos() {
            return GRUPOS
                .map(k => ({ k, mods: modules.filter(m => (GRUPOS.includes(m.grupo) ? m.grupo : 'otros') === k) }))
                .filter(g => g.mods.length);
        },
        yo() { return String((this.$store.state.user || {}).idusuario || ''); },
        cuenta() {
            const sa = this.admins.filter(a => a.is_super_admin).length;
            return { all: this.admins.length, super: sa, admin: this.admins.length - sa };
        },
        // Super admins primero, después por correo (la API ya los manda por correo).
        visibles() {
            const t = norm(this.q);
            return this.admins
                .filter(a => !this.rol || (this.rol === 'super') === !!a.is_super_admin)
                .filter(a => !t || norm(`${a.correo} ${a.nombre || ''} ${a.apellido || ''}`).includes(t))
                .slice()
                .sort((a, b) => (b.is_super_admin ? 1 : 0) - (a.is_super_admin ? 1 : 0));
        },
    },

    watch: {
        q() { this.syncUrl(); },
        rol() { this.syncUrl(); },
    },

    created() {
        this._avisoT = null;
        this._resT = null;
        if (!this.isSuperAdmin) {
            this.$router.push('/admin');
            return;
        }
        this.cargar();
    },

    beforeDestroy() {
        clearTimeout(this._avisoT);
        clearTimeout(this._resT);
    },

    methods: {
        // ── Datos ───────────────────────────────────────────────────────
        async cargar() {
            const req = (this._req = (this._req || 0) + 1);
            this.cargando = true;
            this.error = false;
            try {
                const { data } = await axios.get(apiUrls.adminPermissions);
                if (req !== this._req) return;
                this.admins = data.data || [];
                const ids = this.admins.map(a => a.idusuario);
                this.abiertos = this.abiertos.filter(id => ids.includes(id));
            } catch (e) {
                if (req !== this._req) return;
                console.error('[Permisos] No se pudieron cargar los admins', e);
                this.error = true;
            } finally {
                if (req === this._req) this.cargando = false;
            }
        },
        syncUrl() {
            const query = {};
            if (this.q.trim()) query.q = this.q.trim();
            if (this.rol) query.rol = this.rol;
            if (JSON.stringify(query) === JSON.stringify(this.$route.query)) return;
            this.$router.replace({ query }).catch(() => {});
        },
        // Reemplaza la fila con lo que devolvió la API (estado efectivo).
        reemplazar(a, fila) {
            const i = this.admins.findIndex(x => x.idusuario === a.idusuario);
            if (i !== -1 && fila) this.$set(this.admins, i, fila);
        },
        msgApi(e, fallback) {
            const r = e && e.response;
            // Los mensajes de la API vienen en español: solo se muestran en es.
            if (r && r.data && r.data.message && this.$i18n.locale === 'es' && r.status === 422) return r.data.message;
            return fallback;
        },

        // ── Formato ─────────────────────────────────────────────────────
        titulo(m) {
            const k = `admin_menu.m.${m.key}.t`;
            if (this.$te(k)) return this.$t(k);
            const t = this.$t(m.title);
            return t === m.title ? m.title : t;
        },
        nombre(a) { return [a.nombre, a.apellido].filter(Boolean).join(' ') || this.$t('admin_permisos.list.no_name'); },
        iniciales(a) {
            const p = [a.nombre, a.apellido].filter(Boolean).join(' ').trim().split(/\s+/).filter(Boolean);
            if (!p.length) return String(a.correo || '?')[0].toUpperCase();
            return ((p[0] || '?')[0] + (p.length > 1 ? p[p.length - 1][0] : '')).toUpperCase();
        },
        esYo(a) { return String(a.idusuario) === this.yo; },
        tiene(a, key) { return Array.isArray(a.admin_permissions) && a.admin_permissions.includes(key); },
        activos(a) { return modules.filter(m => this.tiene(a, m.key)); },
        // Nadie se puede sacar a sí mismo el acceso a esta pantalla.
        propioPermisos(a, m) { return m.key === 'permissions' && this.esYo(a); },
        // El dueño (por entorno) no cambia de rol; uno mismo no se baja de super.
        rolBloqueado(a) { return !!a.role_locked || (this.esYo(a) && !!a.is_super_admin); },

        alternar(a) {
            const i = this.abiertos.indexOf(a.idusuario);
            if (i === -1) this.abiertos.push(a.idusuario);
            else this.abiertos.splice(i, 1);
        },
        resaltar(id) {
            clearTimeout(this._resT);
            this.resaltado = id;
            this._resT = setTimeout(() => { this.resaltado = null; }, 2400);
        },

        // ── Agregar ─────────────────────────────────────────────────────
        async agregar() {
            if (this.agregando) return;
            const correo = this.nuevo.correo.trim().toLowerCase();
            if (!EMAIL.test(correo)) {
                this.errCorreo = this.$t(correo ? 'admin_permisos.new.err_email' : 'admin_permisos.new.err_empty');
                this.$nextTick(() => this.$refs.correo && this.$refs.correo.focus());
                return;
            }
            const existe = this.admins.find(a => String(a.correo || '').toLowerCase() === correo);
            if (existe) {
                // El POST sobreescribiría sus permisos: mejor ir a editarlo.
                this.errCorreo = this.$t('admin_permisos.new.err_exists');
                this.q = '';
                this.rol = '';
                if (!this.abiertos.includes(existe.idusuario)) this.abiertos.push(existe.idusuario);
                this.irA(existe.idusuario);
                return;
            }
            if (this.nuevo.super) {
                const ok = await this.confirmar({
                    titulo: this.$t('admin_permisos.k.super_t'),
                    texto: this.$t('admin_permisos.k.super_p', { n: correo }),
                    ok: this.$t('admin_permisos.k.super_ok'),
                });
                if (!ok) return;
            }
            this.agregando = true;
            this.errCorreo = '';
            try {
                const { data } = await axios.post(apiUrls.adminPermissions, {
                    correo,
                    admin_permissions: this.nuevo.mods.slice(),
                    is_super_admin: !!this.nuevo.super,
                });
                this.nuevo = { correo: '', super: false, mods: [] };
                this.q = '';
                this.rol = '';
                await this.cargar();
                const id = data && data.data ? data.data.idusuario : null;
                this.avisar(this.$t('admin_permisos.toast.added', { n: correo }), 'ok');
                if (id) this.irA(id);
            } catch (e) {
                const r = e && e.response;
                if (r && r.status === 404) {
                    this.errCorreo = this.$t('admin_permisos.new.err_nouser');
                    this.$nextTick(() => this.$refs.correo && this.$refs.correo.focus());
                } else if (r && r.status === 422) {
                    this.errCorreo = this.$t('admin_permisos.new.err_email');
                    this.$nextTick(() => this.$refs.correo && this.$refs.correo.focus());
                } else {
                    console.error('[Permisos] No se pudo agregar', e);
                    this.avisar(this.$t('admin_permisos.toast.add_fail'), 'error');
                }
            } finally {
                this.agregando = false;
            }
        },
        irA(id) {
            this.resaltar(id);
            this.$nextTick(() => {
                const el = this.$el.querySelector(`.pe-card[data-id="${Number(id)}"]`);
                if (el) el.scrollIntoView({ behavior: 'smooth', block: 'center' });
            });
        },

        // ── Editar ──────────────────────────────────────────────────────
        async guardarPermisos(a, next, okMsg) {
            const antes = Array.isArray(a.admin_permissions) ? a.admin_permissions.slice() : [];
            this.$set(a, 'admin_permissions', next);
            this.guardando = a.idusuario;
            try {
                const { data } = await axios.patch(`${apiUrls.adminPermissions}/${a.idusuario}`, { admin_permissions: next });
                this.reemplazar(a, data && data.data);
                if (okMsg) this.avisar(okMsg, 'ok');
            } catch (e) {
                console.error('[Permisos] No se pudo actualizar', e);
                this.$set(a, 'admin_permissions', antes);
                this.avisar(this.msgApi(e, this.$t('admin_permisos.toast.perm_fail')), 'error');
            } finally {
                this.guardando = null;
            }
        },
        alternarModulo(a, key, ev) {
            const on = ev.target.checked;
            const actual = Array.isArray(a.admin_permissions) ? a.admin_permissions : [];
            const next = on ? Array.from(new Set(actual.concat(key))) : actual.filter(k => k !== key);
            const m = modules.find(x => x.key === key);
            this.guardarPermisos(a, next, this.$t(on ? 'admin_permisos.toast.perm_on' : 'admin_permisos.toast.perm_off', { m: m ? this.titulo(m) : key, n: this.nombre(a) }));
        },
        // Marcar o quitar todas: un solo PATCH. Las keys viejas (fuera de
        // modules.json) se conservan; la propia de permisos no se quita.
        todos(a, on) {
            const keys = modules.map(m => m.key);
            const actual = Array.isArray(a.admin_permissions) ? a.admin_permissions : [];
            const ajenas = actual.filter(k => !keys.includes(k));
            const next = on ? ajenas.concat(keys) : ajenas.concat(this.esYo(a) ? ['permissions'] : []);
            if (next.slice().sort().join() === actual.slice().sort().join()) return;
            this.guardarPermisos(a, next, this.$t(on ? 'admin_permisos.toast.all_on' : 'admin_permisos.toast.all_off', { n: this.nombre(a) }));
        },
        async cambiarRol(a, sup) {
            if (!!a.is_super_admin === sup || this.rolBloqueado(a)) return;
            const ok = await this.confirmar(sup ? {
                titulo: this.$t('admin_permisos.k.super_t'),
                texto: this.$t('admin_permisos.k.super_p', { n: this.nombre(a) }),
                ok: this.$t('admin_permisos.k.super_ok'),
            } : {
                titulo: this.$t('admin_permisos.k.admin_t'),
                texto: this.$t('admin_permisos.k.admin_p', { n: this.nombre(a) }),
                ok: this.$t('admin_permisos.k.admin_ok'),
            });
            if (!ok) { this.radiosRol(a); return; }
            const antes = a.is_super_admin;
            this.$set(a, 'is_super_admin', sup);
            this.guardando = a.idusuario;
            try {
                const { data } = await axios.patch(`${apiUrls.adminPermissions}/${a.idusuario}`, { is_super_admin: sup });
                this.reemplazar(a, data && data.data);
                this.avisar(this.$t(sup ? 'admin_permisos.toast.now_super' : 'admin_permisos.toast.now_admin', { n: this.nombre(a) }), 'ok');
            } catch (e) {
                console.error('[Permisos] No se pudo cambiar el rol', e);
                this.$set(a, 'is_super_admin', antes);
                this.avisar(this.msgApi(e, this.$t('admin_permisos.toast.role_fail')), 'error');
                this.radiosRol(a);
            } finally {
                this.guardando = null;
            }
        },
        // El navegador ya marcó el radio elegido: si se cancela o falla, se
        // vuelve a marcar el rol vigente (Vue no lo repinta si el dato no cambió).
        radiosRol(a) {
            this.$nextTick(() => {
                const els = this.$el.querySelectorAll(`input[name="pe-role-${Number(a.idusuario)}"]`);
                els.forEach((el, i) => { el.checked = (i === 1) === !!a.is_super_admin; });
            });
        },
        async quitar(a) {
            if (a.role_locked || this.esYo(a)) return;
            const ok = await this.confirmar({
                titulo: this.$t('admin_permisos.k.del_t'),
                texto: this.$t('admin_permisos.k.del_p', { n: this.nombre(a), c: a.correo }),
                ok: this.$t('admin_permisos.k.del_ok'),
                peligro: true,
            });
            if (!ok) return;
            this.guardando = a.idusuario;
            try {
                await axios.delete(`${apiUrls.adminPermissions}/${a.idusuario}`);
                this.admins = this.admins.filter(x => x.idusuario !== a.idusuario);
                this.abiertos = this.abiertos.filter(id => id !== a.idusuario);
                this.avisar(this.$t('admin_permisos.toast.removed', { n: a.correo }), 'ok');
                this.$nextTick(() => { const h = this.$refs.lista; if (h) h.scrollIntoView({ behavior: 'smooth', block: 'start' }); });
            } catch (e) {
                console.error('[Permisos] No se pudo quitar', e);
                this.avisar(this.msgApi(e, this.$t('admin_permisos.toast.del_fail')), 'error');
            } finally {
                this.guardando = null;
            }
        },

        // ── Confirmación y aviso ─────────────────────────────────────────
        confirmar({ titulo, texto, ok, peligro }) {
            return new Promise(resolve => {
                this._modalFoco = document.activeElement;
                this.modal = { titulo, texto, ok, peligro: !!peligro, resolve };
                this.$nextTick(() => { if (this.$refs.modalOk) this.$refs.modalOk.focus(); });
            });
        },
        responderModal(v) {
            if (!this.modal) return;
            const { resolve } = this.modal;
            this.modal = null;
            const el = this._modalFoco;
            this.$nextTick(() => { if (el && document.contains(el)) el.focus(); });
            resolve(v);
        },
        teclaModal(e) {
            if (e.key === 'Escape') { e.preventDefault(); this.responderModal(false); return; }
            if (e.key !== 'Tab') return;
            const els = Array.from(this.$refs.modalCard.querySelectorAll('button'));
            const first = els[0], last = els[els.length - 1];
            if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
            else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
        },
        avisar(txt, tipo) {
            clearTimeout(this._avisoT);
            this.aviso = { txt, tipo: tipo || 'ok' };
            this._avisoT = setTimeout(() => { this.aviso = null; }, 3200);
        },
    },
};
</script>

<style src="../../BankInformation/bkCuenta.css"></style>
<style src="../../Cuenta/cuentaMenu.css"></style>
<style src="../Usuarios/usuariosAdmin.css"></style>
<style src="./permisosAdmin.css"></style>
